import { createSlice } from '@reduxjs/toolkit'
import BigNumber from "bignumber.js";

const initialState = {
    allowance: "0",
    totalStaked: "0",
    userBalance: "0",

    roobeeBalance: "0",

    userUnlockedBalance: "0",
    userReward: "0",

    locks: []
}

const stakingSlice = createSlice({
    name: 'staking',
    initialState,
    reducers: {
        setAllowance(state, action) {
            state.allowance = action.payload;
        },
        setTotalStaked(state, action) {
            state.totalStaked = action.payload;
        },
        setUserBalance(state, action) {
            state.userBalance = action.payload;
        },

        setRoobeeBalance(state, action) {
            state.roobeeBalance = action.payload;
        },

        setUserUnlockedBalance(state, action) {
            state.userUnlockedBalance = action.payload;
        },
        setUserReward(state, action) {
            state.userReward = action.payload;
        },

        setLocks(state, action) {
            state.locks = action.payload;
        }
    },
});

export const {
    setAllowance,
    setTotalStaked,
    setUserBalance,
    setUserUnlockedBalance,
    setUserReward,
    setRoobeeBalance,
    setLocks,
} = stakingSlice.actions;
export default stakingSlice.reducer;

function fetchStakingData({account, staking, roobee}) {
    return dispatch => {
        if (staking) {
            staking.totalSupply().then(result => {
                dispatch(setTotalStaked(result.toString()));
            });
        }
        if (staking && account) {
            staking.balanceOf(account).then(result => {
                dispatch(setUserBalance(result.toString()));
            });
            staking.earned(account).then(result => {
                dispatch(setUserReward(result.toString()));
            });
            staking.unlockedBalanceOf(account).then(result => {
                dispatch(setUserUnlockedBalance(result.toString()));
            });
            staking.lockedBalanceOf(account).then(result => {
                dispatch(setLocks(result.map(l => {
                    return {amount: l.amount.toString(), type: "Year", endTimestamp: l.endTimestamp.toNumber()};
                })));
            });
        }
        if (roobee && account) {
            roobee.balanceOf(account).then(result => {
                dispatch(setRoobeeBalance(result.toString()));
            });
            roobee.allowance(account, process.env.REACT_APP_STAKING_ADDRESS).then(result => {
                dispatch(setAllowance(result.toString()));
            });
        }
    };
}

export { fetchStakingData };
